module.exports = __webpack_public_path__ + "static/media/lto-dill-mb-fr.bd28496d.jpg";